import { StripeError } from '@stripe/stripe-js'
import { put, takeEvery } from 'redux-saga/effects'

import { StripeActions } from 'features'

export function* confirmPaymentSaga(action: ReturnType<typeof StripeActions.confirmPaymentRequest>): Generator {
  try {
    const { stripe, elements } = action.payload

    const { error } = (yield stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/success`,
      },
    })) as {
      error: StripeError
    }

    if (error) {
      throw new Error(error.message)
    }
  } catch {
    yield put(StripeActions.confirmPaymentFailure())
  }
}

function* stripeSagas(): Generator {
  yield takeEvery(StripeActions.confirmPaymentRequest, confirmPaymentSaga)
}

export { stripeSagas }
